import type { CSSProperties } from "react";

// lucide's star, drawn once per page. <StarSprite /> (root layout) holds the path; every <StarIcon />
// is an <svg> that <use>s it, so a star costs ~200 bytes instead of lucide's ~630. The homepage
// draws 175 of them (rating rows on every review card and gallery slide), and each one sat in the
// HTML and again in the RSC payload. The outer <svg> keeps lucide's attributes (viewBox, stroke,
// fill, caps, joins), which the <use>d path inherits, so a star renders exactly as <Star /> did.
const STAR_ID = "vp-star";

export function StarSprite() {
  return (
    <svg aria-hidden="true" style={{ height: 0, overflow: "hidden", position: "absolute", width: 0 }}>
      <path
        d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
        id={STAR_ID}
      />
    </svg>
  );
}

export function StarIcon({
  className,
  strokeWidth = 2,
  style,
}: {
  className?: string;
  strokeWidth?: number;
  style?: CSSProperties;
}) {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      style={style}
      viewBox="0 0 24 24"
      width="24"
    >
      <use href={`#${STAR_ID}`} />
    </svg>
  );
}
